import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { ProjectInfo } from "../../../../../store/ProjectsListStore";
import { SourceTypeMap } from "../../../../../store/ExternalEpmConnectStore";
import { CopyScheduleState, SourceInfo } from "../../../../../entities/common";
import { Field } from "../../../../../entities/Metadata";
import { ExpandedMultilineTextFormatter } from '../../../../common/formatters/ExpandedMultilineTextFormatter';

const stateLabels: Record<CopyScheduleState, string> = {
    [CopyScheduleState.Queued]: 'Queued',
    [CopyScheduleState.InProgress]: 'In progress',
    [CopyScheduleState.Succeeded]: 'Succeeded',
    [CopyScheduleState.Failed]: 'Failed',
};

export default class CopyScheduleStatus extends React.Component<IListViewFieldColumn<ProjectInfo>> {
    public render() {
        const { entity, field } = this.props;
        if (!field) {
            return <span>Invalid column configuration</span>;
        }

        const sources = SourceInfo.getCopyScheduleStatusSources(entity.sourceInfos);
        const hasFailed = sources.some(_ => _.copyScheduleStatus.state === CopyScheduleState.Failed);
        const message = sources
            .flatMap(_ => [
                [SourceTypeMap[_.type], stateLabels[_.copyScheduleStatus.state]]
                .filter(part => !!part)
                .join(' - '),
                _.copyScheduleStatus.error
            ])
            .join('\n');

        return (
            <>
                {sources.length > 0 && <span className={`list-grid-cell ${hasFailed ? 'copy-schedule-failed' : ''}`}>
                    <ExpandedMultilineTextFormatter isMultiline value={message} className='selectable-text' />
                </span>}
            </>
        );
    }

    public static getValue(entity: ProjectInfo, field: Field): string | undefined {
        return SourceInfo.getCopyScheduleStatus(entity.sourceInfos)?.label;
    }

    public static getSearchValue(entity: ProjectInfo, field: Field): string | undefined {
        return CopyScheduleStatus.getValue(entity, field);
    }
}
